import AuthService from "../../../../../api/AuthService";
import PurchaseEditPage from "../../../../../entities/DashboardPage/AccountingModule/Purchase/PurchaseEdit";
import React, { useEffect, useState } from "react";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";
import { useLocation, useNavigate } from "react-router-dom";

const PurchaseEdit = () => {
  const [loading, setLoading] = useState();
  const [itemList, setItemList] = useState();
  const [supplierList, setSupplierList] = useState();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const {state} = useLocation();
  const {item} = state||{};
  const [data, setData] = useState();

  useEffect(() => {
    getItem();
    getSupplierList();
    getAllBanks();
  }, []);

  const handleEditPurchase = async (id,supplierName,invoicesDate,duesDate,billNumber,category,orderNumber,product,discount,tax,paymentStatus,paymentMode,remarks,totalAmount,grandTotal,bankDetails) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.handleEditPurchase(id,supplierName,invoicesDate,duesDate,billNumber,category,orderNumber,product,discount,tax,paymentStatus,paymentMode,remarks,totalAmount,grandTotal,bankDetails);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        await getsupplierPurchase(supplierName?.supplierId);

      } else {
        
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  const getSupplierList = async (text, sort, page) => {
    setLoading(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setSupplierList(result?.data?.suppliers);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getItem = async (text) => {
    setLoading(true);
    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true); 
    try {
      const result = await AuthService.getAllBanks();
      if (result?.success) {
        setData(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getsupplierPurchase = async (supplierName) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSuppliersPurchase(supplierName);
      if (result?.success) {
        const data = result?.data
        navigate("/dashboard/supplierDetails", {
          state: {
            supplierList,
            purchaseList:data,
          },
        })
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <PurchaseEditPage loading={loading} data={data} itemList={itemList} item={item} handleItemsList={getItem} supplierList={supplierList} handleSupplierList={getSupplierList} handleEditPurchase={handleEditPurchase} />
  )

}

export default PurchaseEdit;
